import type { VoiceNavVersionInfo } from '../api/apiConfig'
import { getSupportedLanguage } from './chatUiLocale'

export const FRONTEND_BUILD_LABEL = '08-07-26 18:00'

const VERSION_LABELS = {
  en: {
    front: 'Frontend',
    back: 'Backend',
    backUnavailable: 'Backend unavailable',
  },
  fr: {
    front: 'Interface',
    back: 'Serveur',
    backUnavailable: 'Serveur indisponible',
  },
} as const

export function buildComposerVersionLabel(
  backendInfo: VoiceNavVersionInfo | null,
  frontendLabel: string = FRONTEND_BUILD_LABEL,
): string {
  const labels = VERSION_LABELS[getSupportedLanguage()]
  const front = `${labels.front} ${frontendLabel}`
  if (!backendInfo) return `${front} · ${labels.backUnavailable}`
  const date = backendInfo.started_at_label.trim()
  if (date) return `${front} · ${labels.back} ${date}`
  return `${front} · ${labels.backUnavailable}`
}
